import { useOnlineStatus } from "../hooks/useOnlineStatus";

export default function OfflineBanner() {
  const online = useOnlineStatus();
  if (online) return null;
  return (
    <div
      role="status"
      aria-live="polite"
      className="bg-accent text-ink-950 text-center text-xs font-semibold py-1.5 px-3"
    >
      You're offline — submissions and live data are unavailable until the network returns.
    </div>
  );
}
